import { Div, Image } from "@tblabs/truffle";
import { TextWithPictureField } from "../../../Models/Description/TextWithPicture/TextWithPictureField";
import { Markdown } from "../../Utils/Markdown";
import { Heading } from "../../Heading";


export class TextWithPicturePrinterV1 extends Div
{
    constructor(field: TextWithPictureField)
    {
        super("TextWithPicturePrinter");

        if (field.PicturePosition.Is("left"))
        {
            this.Append(
                new Div("image-container").Append(
                    new Image(field.PictureUrl.value)
                ),
                new Markdown(field.Text.value).Class("text-container")
            )
        }
        else
        {
            this.Append(
                new Markdown(field.Text.value).Class("text-container"),
                new Div("image-container").Append(
                    new Image(field.PictureUrl.value)
                ),
            )
        }
    }
}

export class TextWithPicturePrinterV2 extends Div
{
    constructor(header: string, field: TextWithPictureField)
    {
        const isLeft = field.PicturePosition.Is("left");
        
        super("content-block" + (isLeft ? " content-block--reverse" : ""));

        this.Append(
            new Div("content-block__container").Append(
                new Div("content-block__image").Append(
                    new Image(field.PictureUrl.value).Class("content-block__img")
                ),
                new Div("content-block__content").Append(
                    new Heading(header, 2, "content-block__title"),
                    new Markdown(field.Text.value).Class("content-block__text")
                )
            )
        )
    }
}
